// extracted by mini-css-extract-plugin
export default {"row":"styles_row__1nYLP","left":"styles_left__ZpcoL","preview":"styles_preview__nDlHs","type":"styles_type__H39Gr","label":"styles_label__Cwrzd","table":"styles_table__upPNE"};